import React, { useState, useEffect, useMemo } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";
import '../../assets/customstyle.css';

import Breadcrumb from "../../components/Common/Breadcrumb";

// import {
//   Button,
//   Card,
//   Col,

//   Row,
//   Nav,

//   NavItem,

// } from "reactstrap";
import {
    Table,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    Button,
    Nav,
    NavItem,
    NavLink,
    Row,
    Container,
    TabContent,
    TabPane,
    Modal,
    ModalHeader,
    ModalBody
} from "reactstrap";
import layout2 from "../../assets/images/nodatafound.jpg";




import { getLoggedInUser, getRefreshToken } from "../../helpers/fakebackend_helper";
import axios from "axios";
import * as url from "../../../src/helpers/url_helper";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import Spinners from "../../components/Common/Spinner";

import './full.css'
import { t } from "i18next";
const TestSeries = (location) => {
    const data = useLocation();
    //meta title
    document.title = "Test Series | ICE - Student Portal";
    const [isLoading, setLoading] = useState(false);
    const [boardCategoryList, setBoardCategoryList] = useState([])
    const [boardCategoryTopicList, setBoardCategoryTopicList] = useState([])
    const [details, setdetails] = useState([])
    const [cid, setcid] = useState([])
    const user = getLoggedInUser();
    const navigate = useNavigate();

    const [subscriptionID, setSubscriptionID] = useState(0);
    const [planID, setPlanID] = useState(0)
    const [categoryID, setCategoryID] = useState(0)
    const [subConfID, setSubConfID] = useState(0)    // pagination
    const [ reattemptAlertModal, setReattemptAlertModal ] = useState(false);
    const [remainingTest, setTemainingTest] = useState("")
    const [timeExpiryModal, setTimeExpiryModal] = useState(false);
    // const [jobGridData, setJobGridData] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const perPageData = 8;
    const indexOfLast = currentPage * perPageData;
    const indexOfFirst = indexOfLast - perPageData;
    const [testDetails, setTestDetails] = useState({});
    const currentData = useMemo(() => boardCategoryList?.slice(indexOfFirst, indexOfLast), [boardCategoryList, indexOfFirst, indexOfLast])
    const [testType, setTestType] = useState(1);
    const [ newTest, setNewTest] = useState(1);
    const [planName, setPlanName] = useState("");
    const [planAmount, setPlanAmount] = useState("");   
    const [planValidity, setPlanValidity] = useState("");
    const [ planCategoty, setPlanCategory] = useState("");
    
    // useEffect(() => {
    //     setJobGridData(currentData);
    // }, [currentData]);

    const colorArray = [
        { "badge_color": "text-bg-info", "bg_color": "btn-soft-info" },
        { "badge_color": "text-bg-warning", "bg_color": "btn-soft-warning" },
        { "badge_color": "text-bg-success", "bg_color": "btn-soft-success" },
        { "badge_color": "text-bg-secondary", "bg_color": "btn-soft-secondary" },
        { "badge_color": "text-bg-primary", "bg_color": "btn-soft-primary" },
        { "badge_color": "text-bg-dark", "bg_color": "btn-soft-dark" },
    ]
    useEffect(() => {
        if (data?.state?.subscription_id) {
        setSubscriptionID(data?.state?.subscription_id)
        setPlanID(data?.state?.plan_id)
        setCategoryID(data?.state?.category_id)
        setSubConfID(data?.state?.sub_conf_id)
        }
        examModelList(data?.state?.subscription_id,data?.state?.plan_id, data?.state?.category_id);
    }, []);

    const toggleModal = () => {
       setReattemptAlertModal(!reattemptAlertModal);
      };
      const toggleModal1 = () => {
        setTimeExpiryModal(!timeExpiryModal);
       };
   

       const examModelList = async (varsubscription_id, varplan_id, varcategory_id) => {
        setLoading(true);   // 🔥 START LOADER
    
        const data = {
            stid: Number(user.UserInfo.stid),
            subscription_id: Number(varsubscription_id),
            plan_id: Number(varplan_id)
        };
    
        const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };
    
        try {
            const response = await axios.post(
                url.BASE_URL + 'test/getTestSeries',
                data,
                config
            );
    
            if (response && response?.data?.body?.statusFlag === 3) {
                toast.error(response.data.body.message, { autoClose: 2000 });
                localStorage.removeItem("authUser");
                window.location.reload();
                return;
            }
    
            if (response?.data?.status === 200) {
                setPlanCategory(response?.data?.body?.categoryName);
                setPlanName(response?.data?.body?.planDetails?.plan_name);
    
                if (response?.data?.body?.test_series_list) {
                    setdetails(response.data.body.test_series_list);
                } else {
                    toast.error(response.data.body.message);
                }
            }
        } catch (error) {
            console.error("student Test Series API Error:", error);
        } finally {
            setLoading(false);   // 🔥 STOP LOADER (VERY IMPORTANT)
        }
    };
    

    // const examModelList = async (varsubscription_id, varplan_id, varcategory_id) => {
    //     setLoading(true);
    //     const data = {
    //         stid: Number(user.UserInfo.stid),
    //         subscription_id: Number(varsubscription_id),
    //         plan_id: Number(varplan_id)

    //     };
    //     const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };

    //     try {
    //         const response = await axios.post(url.BASE_URL + 'test/getTestSeries', data, config);
    //         if (response && response?.data?.body?.statusFlag === 3) {
    //             toast.error(response.data.body.message, { autoClose: 2000 });
    //             localStorage.removeItem("authUser");
    //             window.location.reload();
    //             return;
    //         }

    //         if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
    //             const refresh = await getRefreshToken();

    //             if (refresh) {
    //                 if (Number(refresh) === constants.invalidRefreshToken) {
    //                     logoutUser();
    //                 } else {
    //                     await examModelList();
    //                 }
    //             }
    //         }
    //          if (response?.data?.status === 200) {
    //             setPlanCategory(response?.data?.body?.categoryName);
    //                 setPlanName(response?.data?.body?.planDetails?.plan_name);
    //             if(response?.data?.body?.test_series_list) {
    //                 setdetails(response.data.body.test_series_list);
    //                 // setcid(response.data.body.modelexamList[0].cid)
    //             } else {
    //                 toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
    //             }
    //         }
    //     } catch (error) {
    //         // Handle error
    //         console.error("student Test Series API Error:", error);
    //     }
        
    // };

    const [activeTab, setActiveTab] = useState(0);

    const [isOpen, setIsOpen] = useState(true)
    const [activeGroupName, setActiveGroupName] = useState("");
    const [activeSubjectName, setActiveSubjectName] = useState("");
    const [activeSubjectTab, setActiveSubjectTab] = useState("1");
    const toggle = () => setIsOpen(!isOpen);
    const [isAllowTest, setIsAllowTest] = useState(1);

    useEffect(() => {
        if (boardCategoryList && boardCategoryList.length > 0) {
            setActiveTab(0)
            setActiveGroupName(boardCategoryList[0].ex_name.concat("-").concat(boardCategoryList[0].exct_name));
        }
    }, [boardCategoryList]);

    useEffect(() => {
        if (boardCategoryTopicList && boardCategoryTopicList.length > 0) {
            setActiveSubjectTab(0)
            setActiveSubjectName(boardCategoryTopicList[0].topicname);
        }
    }, [boardCategoryTopicList]);

    const checReattempt = (item, varisAllowTest, varisnewtest,vartesttype) =>
    {
   
        setTemainingTest((Number(item?.balance_test_count) -  1)?.toString())
        setIsAllowTest(varisAllowTest)
        if(item.attended_test_count > 0)
        {
            setReattemptAlertModal(true)
            return false
        }
        else{
            if(varisAllowTest == 0)
            {
                setTimeExpiryModal(true)
                return false
            }
            else{

                if(vartesttype == 1)
                    {
                        var tempflag = categoryID == 1 ? 0 : 2
                        navigate("/onlinetest", { state: {new_test:varisnewtest,flag: tempflag, sub_conf_id: subConfID, plan_id: planID, category_id: categoryID, subscription_id: subscriptionID, test_type: vartesttype, testDetails:item } });


                    }
                    else{
                        navigate("/Instructionspage", { state:{new_test:varisnewtest,test_type:vartesttype,testDetails:item, subscription_id:subscriptionID, category_id:categoryID, plan_id:planID, sub_conf_id:subConfID} });
        
                    }
              
                return true
            }
            
        }
       
    }

     async function checkExpiry  (item, isnewtest, testtype) {
     //   testypeid denotes reume or reattempt
        const user = getLoggedInUser()
        setLoading(true)
        const params = {
          "stid": Number(user.UserInfo.stid),
          "plan_id": Number(planID),
          "subscription_id": Number(subscriptionID)
        };

        const config = { headers: { authorization: 'Bearer '.concat(user.UserInfo.accessToken) } };

        try {
            const response = await axios.post(url.BASE_URL + 'test/checkTestStartEligibility', params, config);
            if (response && response?.data?.body?.statusFlag === 3) {
                toast.error(response.data.body.message, { autoClose: 2000 });
                localStorage.removeItem("authUser");
                window.location.reload();
                return;
            }

            if (response?.data?.body?.status === '401' || response?.data?.body?.status === 401) {
                const refresh = await getRefreshToken();

                if (refresh) {
                    if (Number(refresh) === constants.invalidRefreshToken) {
                        logoutUser();
                    } else {
                        await checkExpiry(item, isnewtest, testtype)
                    }
                }
            }
            if (response?.data?.body?.statusFlag === 1) {

              if(response?.data?.body?.test_series_list?.length > 0)
              {
              
                if(response?.data?.body?.test_series_list[0]?.is_plan_expired == 1)
                {

                    toast.error("Oops! Plan Expired", { position: toast.POSITION.TOP_RIGHT });
                  
                    return false  
                  
                  
                }
                else{
                    if(Number(item?.isresumed) == 0)
                        checReattempt(item,response?.data?.body?.test_series_list[0]?.is_allow_test,isnewtest,testtype)
                    else
                    {
                        if(testtype == 1)
                        {
                            var tempflag = categoryID == 1 ? 0 : 2
                            navigate("/onlinetest", { state: {new_test:isnewtest,flag: tempflag, sub_conf_id: subConfID, plan_id: planID, category_id: categoryID, subscription_id: subscriptionID, test_type: testtype, testDetails:item } });


                        }
                        else{
                            navigate("/Instructionspage", { state:{new_test:isnewtest,test_type:testtype,testDetails:item, subscription_id:subscriptionID, category_id:categoryID, plan_id:planID, sub_conf_id:subConfID} });
        
                        }
                      
                       
                    }
                       
                        // if(response?.data?.body?.test_series_list[0]?.is_allow_test == 0)
                        // {
                        //        setTimeExpiryModal(true)
                        // }

                }
              
                // if(response?.data?.body?.test_series_list[0]?.is_plan_expired == 0 && response?.data?.body?.test_series_list[0]?.is_allow_test == 1)
                // {
                //     checReattempt(item)
                // }
              }
              else
              {
                toast.error("Oops! Plan Expired", { position: toast.POSITION.TOP_RIGHT });
                setLoading(false)
                return false
              }

            } else {
                toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
            }
            setLoading(false)
        } catch (error) {
            // Handle error
            //console.error("Change Password API Error:", error);
        } finally {

        }
    }

    const handleClick = (item) => {
        checkExpiry(item, 1, 2)
        setTestDetails(item)
        setTestType(2)
        setNewTest(1)
    //    setTimeout(() => {
    //     navigate("/Instructionspage", { state:{testDetails:item, subscription_id:subscriptionID, category_id:categoryID, plan_id:planID, sub_conf_id:subConfID} });
        
    //    }, 10);
       
       
    };
    // test type = 0 for reattempt, 1 for resume , 2 for new test
    // isnew test 0 for call start test, 1 for reattempt or resume

    const reattempt = (item) => {
        checkExpiry(item, 0, 0)
        setTestDetails(item)
        setTestType(0)
        setNewTest(0)
    };
    const resume = (item) => {
        checkExpiry(item,0, 1)
        setTestDetails(item)
        setTestType(1)
        setNewTest(0)
    };

    const review = (item) => {

        navigate('/reviewtest', { state: { id: Number(item.test_id), plan_name:planName, plan_category:planCategoty, test_name:item.test_name } })
    };

    return (
        <React.Fragment>
 <div className="page-content">
      <Container fluid>
      <Breadcrumb  breadcrumbItem="Test Series" />
          

            <Row>

                <Col lg={12} className="mainpage1">
                {isLoading ? (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
        <Spinners setLoading={setLoading} />
    </div>
) : (
    <>
               
                <Card className="w-300 ">
                    <CardBody >
                      <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{planName}</div>

                      <div className="row" style={{ paddingTop: '8px' }}>
                        <div className="col-md-12">
                          <p style={{ color: 'green' }}>
                            {/* <i className="mdi mdi-currency-inr" />
                            {planAmount} | {planValidity} |  */}
                             {planCategoty}
                      

                          </p>
                          
                        </div>
     
                        {/* <div className="col-md-7">
                          <div className="badge rounded-pill bg-success font-size-11" style={{maxWidth:'168px', whiteSpace: 'nowrap', padding: 4 }}>
                            {planCategoty}
                          </div>
                        </div> */}
                      </div>
                    </CardBody>
                    </Card>

        
                    <CardBody>
                        {isLoading ?
                            <Spinners setLoading={setLoading} /> :
                            <Row>

<Col xl="12" >
              {details && Number(details[0]?.balance_test_count) == 0  &&  <div className="bg-danger-subtle card"><div className="text-danger p-3"><h5> <i style={{ fontSize: "20px" }} className="mdi mdi-alert-circle-outline me-2"></i> Test count has been reached.</h5></div></div> }


            </Col>


                                <Col md="12">
                                    <TabContent

                                        className="text-muted mt-4 mt-md-0"
                                    >

                                        <TabPane>
                                            {details && details.length > 0 ?

                                                <Row>
                                                    {(details || []).map((item, key) => (
                                                        <Col xl={3} md={6} key={key}>
                                                            <Card>
                                                                <CardBody>

                                                                    <Row>
                                                                        <Col className="col-11">

                                                                            <h5 className="fs-17 mb-2">
                                                                                <div className="text-dark">{item.test_name}</div> </h5>
                                                                        </Col>
                                                                        <Col className="col-1">
                                                                            {item?.test_id != null && item?.test_completed == 1 && <Col lg="1">
                                                                                <div className="reviebutton2">
                                                                                    <Button type="button" color="primary" className="revbutt" onClick={() => { review(item) }}>
                                                                                        <i className="dripicons-preview font-size-15 align-middle me-1"></i>
                                                                                        {/* <i className="mdi mdi-file-find font-size-15 align-middle me-2"></i> */}
                                                                                        {" "}

                                                                                    </Button>

                                                                                </div>
                                                                            </Col>}
                                                                        </Col>
                                                                    </Row>


                                                                    {/* <h5 className="fs-17 mb-2">
                                                                        <Link to="/Instructionspage" className="text-dark">{item.c_name}</Link> </h5> */}
                                                                    <ul className="list-inline mb-0">

                                                                        <li className="list-inline-item" style={{ width: '100%' }}>
                                                                            <Row>
                                                                                <Col lg="6">
                                                                                    <p className="text-muted fs-14 mb-0"><i className="mdi mdi-clock-time-four-outline"></i> {item.c_duration}</p>
                                                                                </Col>
                                                                                {Number(item?.attended_test_count) > 0 && 
                                                                                   
                                                                                <Col lg="6">
                                                                                    <p className=" fs-14 mb-0 text-danger text-bold">Tests Undertaken : {item?.attended_test_count}</p>
                                                                                </Col>
                                                                                }
                                                                                {/* {item?.testid != null && item?.test_completed == 1 && <Col lg="3">
                                                                                    <div className="reviebutton">
                                                                                        <Button type="button" color="primary" onClick={() => { review(item) }}>
                                                                                            <i className="dripicons-preview font-size-15 align-middle me-2"></i>
                                                                                            
                                                                                            {" "}
                                                                                            Review
                                                                                        </Button>

                                                                                    </div>
                                                                                 
                                                                                </Col>} */}

                                                                            </Row>
                                                                        </li>

                                                                    </ul>
                                                                    <hr className="line3" />
                                                                    <div className="mt-3 hstack gap-2">

                                                                        <div className="col scorecolval mb-4">

                                                                            <div>


                                                                                <p className="text-muted mb-0 scorealign"><i className="fas fa-layer-group iconspace"></i>

                                                                                    Max Score : <span > {item.c_totalmarks}</span>

                                                                                </p>
                                                                                {/* <p className="text-muted mb-0 scores">

                                                                                    <p className='cardnumber1'>
                                                                                        {item.c_totalmarks} </p>   </p> */}
                                                                            </div>
                                                                        </div>
                                                                        <div className="col quescolval mb-4">

                                                                            <div>


                                                                                <p className="text-muted mb-0 quesalign"><i className="dripicons-question iconspace"></i>
                                                                                    Questions : <span> {item.c_totalquestions} </span>




                                                                                </p>

                                                                                {/* <p className="text-muted mb-0 scores">

                                                                                    <p className='cardnumber1'>
                                                                                        {item.c_totalquestions}  </p>   </p> */}
                                                                            </div>
                                                                        </div>
                                                                        {/* <div className="col durationcolval">
                                                                    <div className="text-right rightalign">
                                                                        <p className="text-muted mb-0 duralign"><i className="dripicons-question iconspace"></i>Mark/Question</p>
                                                                        <p className="text-muted mb-0 scores">

                                                                            <p className='cardnumber1'>
                                                                                {item.c_totalmarks}</p>   </p>

                                                                    </div>

                                                                </div> */}


                                                                    </div>
                                                                    {Number(item?.balance_test_count) > 0 &&
                                                                    <div>
                                                                        {item?.test_id != null && item?.test_completed == 1 ? (
                                                                            <div
                                                                                className={Number(item?.isnewtest) == 0 ? "btnModalDesign1" : "btnModalDesign"}

                                                                            //  className="btnModalDesign"
                                                                            ><button onClick={() => reattempt(item)}
                                                                                className=

                                                                                {item?.isnewtest == 0 ? "btn btn-soft-success w-100" :
                                                                                    "btn btn-soft-success w-100"
                                                                                }
                                                                            //  className="btn btn-soft-success w-50"
                                                                            >
                                                                                    Reattempt
                                                                                </button>
                                                                                {/* {Number(item?.isnewtest) == 1 ?
                                                                                    <button onClick={() => handleClick(item)} className="btn btn-soft-primary w-50">
                                                                                        New test
                                                                                    </button>
                                                                                    : ""} */}

                                                                            </div>
                                                                        ) : null}

                                                              
                                                                        {Number(item.test_id) == 0 ? (
                                                                            <button onClick={() => handleClick(item)}
                                                                                className="btn btn-soft-primary w-100"
                                                                            >
                                                                                Start Test
                                                                            </button>
                                                                        ) : null}
                                                                    </div>
                                                    }
                                                              {item?.test_id != null && item?.isresumed == 1 ? (



<div className="btnModalDesign">   <button onClick={() => resume(item)}
    className={item?.isnewtest == 0 ? "btn btn-soft-danger w-100" :
        "btn btn-soft-danger w-100"
    }
// className="btn btn-soft-danger w-50"
>
    Resume
</button>

    {/* {
        item?.isnewtest == 1 ?
            <button onClick={() => handleClick(item)} className="btn btn-soft-primary w-50">
                New test
            </button> : ""} */}
            
            </div>


) : null}

                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                </Row>
                                                :
                                                <div className="imgalignno">

                                                    <img src={layout2} alt="Girl in a jacket" width="450" height="450"></img>
                                                </div>
                                            }
                                            {/* <Paginations
                                                perPageData={perPageData}
                                                data={boardCategoryTopicList}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                                isShowingPageLength={true}
                                                paginationDiv="col-sm-12 col-md-7"
                                                paginationClass="pagination justify-content-end pagination-rounded"
                                            /> */}
                                        </TabPane>

                                    </TabContent>
                                </Col>
                            </Row>
                        }
                    </CardBody>

               
                    </>
)}
                </Col>

            </Row>
            </Container>
            </div>


                    <Modal isOpen={reattemptAlertModal} toggle={toggleModal} centered>
                      <ModalHeader toggle={toggleModal}><span className="fw-bold">Reattempt Alert!!!</span></ModalHeader>
                      <ModalBody>
                        
                        <div className="text-center">
                          <h6>{"If you reattempt this test, your total test count will be reduced by 1. After this reattempt, you will be able to attempt "+Number(remainingTest)+" more test(s). All other tests beyond this limit will be disabled.Are you sure you want to continue?"}</h6>
                          <div className="d-flex justify-content-center">
                            <Button color="primary" onClick={() => {

                                    if(isAllowTest == 0)
                                    {
                                        setTimeExpiryModal(true)
                                        return false
                                    }
                                    else{

                                        if(testType == 1)
                                            {
                                                var tempflag = categoryID == 1 ? 0 : 2
                                                navigate("/onlinetest", { state: {new_test:newTest,flag: tempflag, sub_conf_id: subConfID, plan_id: planID, category_id: categoryID, subscription_id: subscriptionID, test_type: testType, testDetails:testDetails } });
                        
                        
                                            }
                                            else{
                                                navigate("/Instructionspage", { state:{new_test:newTest,test_type:testType, testDetails:testDetails, subscription_id:subscriptionID, category_id:categoryID, plan_id:planID, sub_conf_id:subConfID} });
                                
                                            }
                                      
        
                                    }
                                    

                              // setStatusFlag1(1)
                            
                            }} className="me-2 modalbtn">Yes</Button>
                            <Button color="secondary" onClick={toggleModal} className="modalbtn">No</Button>
                          </div>
                        </div>
                      </ModalBody>
                    </Modal>

                    <Modal isOpen={timeExpiryModal} toggle={toggleModal1} centered>
                      <ModalHeader toggle={toggleModal1}>Expiry Alert!!!</ModalHeader>
                      <ModalBody>
                        
                        <div className="text-center">
                          <h6>{"Your subscription will expire before you can complete this test. Do you want to continue?"}</h6>
                          <div className="d-flex justify-content-center">
                            <Button color="primary" onClick={() => {

                                
if(testType == 1)
    {
        var tempflag = categoryID == 1 ? 0 : 2
        navigate("/onlinetest", { state: {new_test:newTest,flag: tempflag, sub_conf_id: subConfID, plan_id: planID, category_id: categoryID, subscription_id: subscriptionID, test_type: testType, testDetails:testDetails } });


    }
    else{
        navigate("/Instructionspage", { state:{new_test:newTest,test_type:testType, testDetails:testDetails, subscription_id:subscriptionID, category_id:categoryID, plan_id:planID, sub_conf_id:subConfID} });
        
    }

                           
                            
                            }} className="me-2 modalbtn">Yes</Button>
                            <Button color="secondary" onClick={toggleModal1} className="modalbtn">No</Button>
                          </div>
                        </div>
                      </ModalBody>
                    </Modal>
                    <ToastContainer />

        </React.Fragment >
    );
};

export default withRouter(TestSeries);
